import { ISupervisionType } from '../../../APIPackage/DictionariesModule/interfaces/ISupervisionType';
import { IDictionarySelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';

export const getKindControlLabel = (
  kindControlSelectOption: IDictionarySelectOption<ISupervisionType>,
  isUseTransferringAuthorities: boolean,
) => {
  if (
    kindControlSelectOption.transferred &&
    kindControlSelectOption.transferringAuthorities &&
    isUseTransferringAuthorities
  ) {
    const ervkTransferringTitles: string[] = kindControlSelectOption.transferringAuthorities
      .filter(x => x.title !== undefined && x.title !== null)
      .map(x => x.title);
    const ervkTransferringShortTitles: string[] = kindControlSelectOption.transferringAuthorities
      .filter(x => x.shortTitle !== undefined && x.shortTitle !== null)
      .map(x => x.shortTitle);

    if (kindControlSelectOption.shortTitle) {
      if (ervkTransferringShortTitles.length) {
        return `${kindControlSelectOption.number} - ${
          kindControlSelectOption.shortTitle
        } - передано от ${ervkTransferringShortTitles.join(', ')}`;
      }

      return `${kindControlSelectOption.number} - ${
        kindControlSelectOption.shortTitle
      } - передано от ${ervkTransferringTitles.join(', ')}`;
    }

    if (ervkTransferringShortTitles.length) {
      return `${kindControlSelectOption.number} - ${
        kindControlSelectOption.title
      } - передано от ${ervkTransferringShortTitles.join(', ')}`;
    }

    return `${kindControlSelectOption.number} - ${
      kindControlSelectOption.title
    } - передано от ${ervkTransferringTitles.join(', ')}`;
  }

  return `${kindControlSelectOption.code} - ${kindControlSelectOption.label}`;
};
